import React, { useContext, useEffect, useRef } from "react";
import { registerExport, unregisterExport } from "./exportRegistry";
import { moduleIDs } from "./ExportsFormDialog/Helpers";
import { ExportImageContext } from "./ExportImageContext";

export function ExportSection({
  moduleKey,
  index = 1,
  dateRangeLabel,
  exportType, // 'table' | 'chart'
  exportData, // { title, columns, rows, dateRange }
  className,
  style,
  children,
}) {
  const baseId = moduleIDs[moduleKey];
  const domId = `${baseId}_export_${index}`;
  const dateId = `${baseId}_export_dateRange`;
  const ref = useRef(null);
  useEffect(() => {
    registerExport(domId, {
      type: exportType,
      baseId,
      index,
      data: exportData
        ? { ...exportData, dateRange: dateRangeLabel }
        : undefined,
    });
    return () => unregisterExport(domId);
  }, [domId, exportType, exportData, baseId, index, dateRangeLabel]);

  return (
    <div id={domId} className={className} style={style} ref={ref}>
      <div id={dateId} style={{ display: "none" }}>
        {dateRangeLabel ?? ""}
      </div>
      {children}
    </div>
  );
}

export const ExportHeader = ({ moduleKey, isFusionOnly }) => {
  const { imageData } = useContext(ExportImageContext);

  const MODULE_LABEL_MAP = {
    remediator: "Compliance",
    auditor: "Audit",
    documenter: "Documentation",
    continuer: "Continuity",
    educator: "Education",
    investigator: "Incident",
    mitigator: "Risk",
  };

  let label = MODULE_LABEL_MAP[moduleKey?.toLowerCase()] || "Fusion";
  if (isFusionOnly) label = "Fusion";

  return (
    <div
      id={`export-header-${moduleKey}`}
      className="export-header exo2"
      style={{
        display: "none", // keep hidden on screen
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: "20px",
        borderBottom: "none",
        width: "100%",
      }}
    >
      <div
        style={{
          fontWeight: 700,
          fontSize: 20,
          color: "#238787",
          borderBottom: "1px solid #238787",
          display: "inline-block",
          paddingBottom: 0,
        }}
        className="exo2"
      >
        {label}
      </div>
      {
        <img
          src={imageData}
          alt="Org Logo"
          style={{ height: 36, objectFit: "contain" }}
          crossOrigin="anonymous"
          className="logo"
        />
      }
    </div>
  );
};
